import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import "./Register.css";


import Navbar from "../../component/Navbar/Navbar";


import Registration from "../../Registration/Registration";


// ==========================================================
// CLEAR ONLY OLD REGISTRATION DATA
// ==========================================================

const clearRegistrationData = () => {
  const registrationKeys = [
    "formData",
    "registrationData",

    "mobileNumber",
    "memberName",

    "registrationStep",

    "personalData",
    "aadhaarData",
    "documentData",
    "nomineeData",
    "bankData",

    "uploadedDocuments",

    "registrationCompleted",
  ];

  registrationKeys.forEach((key) => {
    localStorage.removeItem(key);
  });
};


// ==========================================================
// REGISTER PAGE
// ==========================================================

function Register() {
  const location = useLocation();

  // ========================================================
  // CHECK EDIT MODE
  // ========================================================

  const editMode =
    location.state?.editMode === true;

  const editStep =
    location.state?.editStep || null;


  // ========================================================
  // NEW REGISTRATION
  //
  // Only clear old data when the user opens registration
  // normally.
  //
  // DO NOT clear data when coming from Review -> Edit.
  // ========================================================

  useEffect(() => {
    if (!editMode) {
      clearRegistrationData();
    }
  }, [editMode]);


  // ========================================================
  // RENDER
  // ========================================================

  return (
    <div className="register-page">

      {/* ==================================================
          TOP BAR
      ================================================== */}

      


      {/* ==================================================
          MAIN NAVIGATION
      ================================================== */}

      <Navbar />


      {/* ==================================================
          REGISTRATION APPLICATION
      ================================================== */}

      <main className="register-main">

        <Registration
          editMode={editMode}
          editStep={editStep}
        />

      </main>


      {/* ==================================================
          FOOTER
      ================================================== */}

      

    </div>
  );
}


export default Register;